import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { trackAi30Event } from '../../utils/eventTracker';
import {
  AI30_ARRIVAL_FLAG,
  AI30_CAMPAIGN,
  AI30_COUPON_CODE,
  AI30_PENDING_COUPON_KEY,
  isAi30Campaign,
} from '../../utils/ai30Campaign';
import './Ai30ArrivalTracker.css';

const Ai30ArrivalTracker = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const { fetchSubscriptionStatus } = useSubscription();
  const startedRef = useRef(false);
  const [blocked, setBlocked] = useState(
    () => {
      try {
        return sessionStorage.getItem(AI30_ARRIVAL_FLAG) === 'blocked';
      } catch {
        return false;
      }
    },
  );

  const onChat = location.pathname === '/chat' || location.pathname.startsWith('/chat/');

  useEffect(() => {
    if (!currentUser || !onChat || !isAi30Campaign()) return;

    let pendingCoupon = '';
    try {
      pendingCoupon = (localStorage.getItem(AI30_PENDING_COUPON_KEY) || '').trim().toUpperCase();
    } catch {
      pendingCoupon = '';
    }
    if (pendingCoupon === AI30_COUPON_CODE) {
      return undefined;
    }

    let cancelled = false;
    const already = (() => {
      try {
        return sessionStorage.getItem(AI30_ARRIVAL_FLAG);
      } catch {
        return null;
      }
    })();
    if (already) {
      setBlocked(already === 'blocked');
      return undefined;
    }

    if (startedRef.current) return undefined;
    startedRef.current = true;

    const run = async () => {
      const status = await fetchSubscriptionStatus(true);
      if (!status || status.verification_failed || status.source === 'unknown') {
        startedRef.current = false;
        return;
      }
      const applied = status.is_pro === true;
      try {
        sessionStorage.setItem(AI30_ARRIVAL_FLAG, applied ? 'applied' : 'blocked');
      } catch {
        // sessionStorage 실패해도 이벤트는 보낸다.
      }
      trackAi30Event(applied ? 'trial_applied' : 'trial_blocked', {
        campaign: AI30_CAMPAIGN,
        stage: applied ? 'applied' : 'blocked',
      });
      if (!cancelled) {
        setBlocked(!applied);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
    // loading을 의존성에 넣으면 안 된다. fetch가 동기 setLoading(true)를 호출해
    // effect가 재실행되고 cleanup이 플래그 기록을 막아 무한 요청이 된다.
  }, [currentUser, fetchSubscriptionStatus, onChat]);

  if (!onChat || !blocked) return null;

  return (
    <aside className="ai30-blocked-banner" role="status">
      <p>이미 30일 무료 체험을 사용하셨어요. 지금 PRO로 이어서 쓸 수 있어요.</p>
      <Link to="/subscription">요금제 보기</Link>
    </aside>
  );
};

export default Ai30ArrivalTracker;
